const Main = ({ children }) => {
    return <div className="main-content__wrap">{children}</div>;
};

export default Main;
